import {RequestStatus, RequestMilestone} from './types.variation'

export const REQUEST_STATUS_NAME: Record<RequestStatus, string> = {
  'created': 'Created',
  'lending-manager-check': 'Lending manager check',
  'financial-controller-check': 'Financial controller check',
  'director-check': 'Director approval',
  'signing-contract': 'Signing contract',
  'ready-to-open': 'Ready to open',
  'financial-controller-review': 'Financial controller review',
  'confirm-open': 'Confirm open',
  'opened': 'Opened',
  'declined': 'Declined',
}

export const REQUEST_MILESTONE_NAME: Record<RequestMilestone, string> = {
  'documents-checked': 'Documents checked',
  'forecast-created': 'Forecast created',
  'establish-fee-checked': 'Establishment fee checked',
  'line-fee-checked': 'Line fee checked',
  'facility-limit-2-checked': 'Facility limit2 checked',
  'financial-checked': 'Financial checked',
  'financial-reviewed': 'Financial reviewed',
  'offer-signed': 'Upload the signed offer',
  'variation-date-confirmed': 'Confirm variation date',
  'forecast-confirmed': 'Create forecast',
  'establish-fee-confirmed': 'Confirm establishment fee',
  'line-fee-confirmed': 'Confirm line fee',
  'facility-limit-2-confirmed': 'Confirm facility limit 2',
  'financial-confirmed': 'Financial confirmed',
  'financial-confirm-reviewed': 'Financial confirm reviewed',
}

export const REQUEST_APPROVED_STATUSES = [
  'approved',
  'confirm-open',
  // 'ready-to-open',
  // 'financial-controller-review',
]
